module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_7.5489cddc.png";